import { format } from 'date-fns';
import { array } from 'yup';
import _get from 'lodash/get';

import { MAX_DATE_OBJECT, MIN_DATE_OBJECT } from '../components';

type getBasicDateRangeValidationPropsT = {
	minDateObject?: Date;
	maxDateObject?: Date;
	customMessages?: Object;
};

export const getBasicDateRangeValidation = (props: getBasicDateRangeValidationPropsT = {}) => {
	const { minDateObject = MIN_DATE_OBJECT, maxDateObject = MAX_DATE_OBJECT, customMessages = {} } = props;
	const minDate = format(minDateObject, 'dd/MM/yyyy');
	const maxDate = format(maxDateObject, 'dd/MM/yyyy');

	return array()
		.test({
			message: _get(customMessages, 'case1', 'Incomplete date range'),
			test: (value: any) => value.length === 2
		})
		.test({
			message: _get(customMessages, 'case2', `"from" date must be in a range of ${minDate} to ${maxDate}`),
			test: (value: any) => value[0] >= minDateObject && value[0] <= maxDateObject
		})
		.test({
			message: _get(customMessages, 'case3', `"from" date must be in a range of ${minDate} to ${maxDate}`),
			test: (value: any) => value[1] >= minDateObject && value[1] <= maxDateObject
		});
};
